/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Headers_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_table_headers_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Headers_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What to try`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_table_headers_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Headers_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以尝试的操作`)
};

/**
* | output |
* | --- |
* | "What to try" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Headers_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_table_headers_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Headers_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Headers_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_table_headers_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_table_headers_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_table_headers_1 as "gc.search_guides.gridcraft_online.sections.3.table.headers.1" }